import { createFileRoute } from '@tanstack/react-router'
import { KnowledgePage } from '../../components/knowledge/KnowledgePage'

type KnowledgeSearch = { q?: string; kind?: string; tab?: 'proposals'; proposal?: string; note?: string }

/** Organization-level knowledge notes and the search across them (spec 2026-10-10-06). */
export const Route = createFileRoute('/$org/knowledge')({
  component: KnowledgePage,
  validateSearch: (search: Record<string, unknown>): KnowledgeSearch => ({
    q: search.q ? String(search.q) : undefined,
    kind: search.kind ? String(search.kind) : undefined,
    // Spec 2026-11-01-01: the Proposals tab, the proposal open in review, and
    // a note to scroll to and highlight (a cited fact's link).
    tab: search.tab === 'proposals' ? ('proposals' as const) : undefined,
    proposal: search.proposal ? String(search.proposal) : undefined,
    note: search.note ? String(search.note) : undefined,
  }),
})
